import classnames from 'classnames';

import classes from './index.module.css';
const testId = 'hamburger';

export const Hamburger = ({ onClick, menuExpanded }) => (
  <div data-testid={testId} className={classnames(classes.hamburger, 'd-flex align-items-center d-block d-lg-none')}>
    <button
      type="button"
      onClick={onClick}
      className={classnames('mt-0 collapsed mr-0 px-0', classes.toggle, {
        [classes.active]: menuExpanded,
      })}
      data-toggle="collapse"
      data-target="#navbar"
      aria-expanded="false"
      aria-controls="navbar"
    >
      <span className="sr-only" />
      <span
        className={classnames('d-block position-relative', classes.iconBar, classes.iconBar1)}
      />
      <span
        className={classnames('d-block position-relative', classes.iconBar, classes.iconBar2)}
      />
      <span
        className={classnames('d-block position-relative', classes.iconBar, classes.iconBar3)}
      />
    </button>
  </div>
);
